import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface IProps {
  tooltip?: string;
  onClick?: () => void;
  style?: React.CSSProperties | undefined;
  className?: string | undefined;
}

const CloseCircleIcon = ({ tooltip, onClick, style, className }: IProps) => {
  return (
    <Tooltip title={tooltip}>
      <CloseCircleOutlined
        onClick={onClick}
        style={{ color: '#ff4d4f', fontSize: 16, ...style }}
        className={className}
      />
    </Tooltip>
  );
};

export default CloseCircleIcon;
